<template>
  <div class="orgDetail">
    <div class="left-box">
      <leftPage :active="4"/>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="tit-left">
          <div class="icon-box">
            <i class="iconfont icon-jianguanguanli"></i>
          </div>
          <b>监管信息</b>
        </div>
        <div class="btn" @click="dialogVisible = true">添加监管信息</div>
      </div>

      <div class="list ">
        <el-table
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="序号"
            width="100px"
            type="index">
          </el-table-column>
          <el-table-column
            label="检查时间"
            prop="do_date">
          </el-table-column>
          <el-table-column
            label="检查人员"
            prop="jiancha_name"
            width="350">
          </el-table-column>
          <el-table-column
            label="操作"
            width="250">
            <template slot-scope="scope" class="flex">
              <div class="edit pointer" @click="edit(scope)">编辑</div>
<!--              <div class="del pointer" @click="del(scope)">删除</div>-->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>

    </div>

    <supervisionDialog
      :dialogVisible="dialogVisible"
      :id="id"
      @handleClose="handleClose"
    />
  </div>
</template>
<script>
import leftPage from "@/views/home/common/leftPage";
import supervisionDialog from "@/views/home/dialog/supervisionDialog";
import {jian_lst} from "@/api";
export default {
  name: "orgDetail",
  data() {
    return {
      dialogVisible:false,
      id:'',
      tableData:[1],
      search:{
        page:1,
        limit:10,
        total:0,
      }
    }
  },
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  components: {
    leftPage,
    supervisionDialog
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    this.list()
  },
  methods: {
// 获取列表
    async list() {
      let _data = await jian_lst(
        this.search.page,
        this.search.limit
      );
      if (_data.status === 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },

    del(scope) {
      this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.expertDel(scope.row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    // async expertDel(id) {
    //   let _data = await del_jian(id)
    //   if (_data.status === 200) {
    //     this.$message.success(_data.msg)
    //     this.list()
    //   } else {
    //     this.$message.error(_data.msg)
    //   }
    // },

    edit(scope){
      this.id = scope.row.id
      this.dialogVisible = true
    },
    handleClose(){
      this.dialogVisible = false
      this.id = ''
      this.list()
    },

  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.orgDetail {
  width: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  display: flex;
  justify-content: flex-start;

  .right-box {
    flex: 1;
    margin-left: 25px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 20px;
    .list {
      width: 100%;
      padding-top: 30px;
    }

    .title-box {
      width: 100%;
      height: 60px;
      border-bottom: solid 2px #e3e7f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
        margin-left: 30px;
      }
      .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;
        padding-bottom: 15px;

        .icon-box {
          width: 30px;
          height: 30px;
          background-image: linear-gradient(-30deg,
            #3579fb 0%,
            #44a3ff 100%);
          box-shadow: 0px 10px 10px 0px
          rgba(50, 150, 255, 0.3);
          border-radius: 10px;
          text-align: center;
          line-height: 30px;
          i {
            font-size: 19px;
            color: #ffffff;
          }
        }

        b {
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          margin-left: 5px;
        }
      }
    }

    .edit {
      font-size: 14px;
      color: #0089ff;
      padding: 4px 10px;
      display: inline-block;
    }
    .del {
      font-size: 14px;
      color: #ff0000;
      padding: 4px 10px;
      display: inline-block;
    }
  }

  .left-box {
    width: 260px;
  }
}
</style>


